import validation from '../../../../modules/Gull/Framework/validation.js';

const showDashboard = {

	init() {

		// Toon en verberg formulier wanner de checkbox van een connector wordt aangevinkt
		$('input.connector-checkbox').on('change', function() {
			$(this).closest('div.connector').find('div.connector-items').removeClass('d-none');
			if (!$(this).prop('checked')) {
				$(this).closest('div.connector').find('div.connector-items').addClass('d-none').find('input,select').removeAttr('data-validate').attr('disabled', true);
			} else {
				$(this).closest('div.connector').find('div.connector-items').find('input,select').each(function() {
					$(this).attr('data-validate', $(this).attr('data-validate_org')).attr('disabled', false);
				});
			}

			// Initialiseer de validatie opnieuw
			$('input[data-validate],select[data-validate]').unbind('blur', validation.checkInputBlur);
			$('input[data-validate],select[data-validate]').blur(validation.checkInputBlur);
		});

		// Tigger toon / verberg functie wanneer de pagina geladen wordt
		$('input.connector-checkbox').trigger('change');

		function setTypeMeldingen() {
			var typeMeldingen = $('#typeMeldingen');
			if ($('#richting').val() == 'inkomend') {
				typeMeldingen.removeAttr('data-validate');
			} else {
				typeMeldingen.attr('data-validate', typeMeldingen.attr('data-validate_org'));
			}
		}

		// TODO: bij inkomend, dan geen type meldingen.
		$('#richting').on('change', setTypeMeldingen);
		setTypeMeldingen();

	}

};

export default showDashboard;
